import { render, staticRenderFns } from "./FilterBuildingType.vue?vue&type=template&id=397d5223&scoped=true&"
import script from "./FilterBuildingType.vue?vue&type=script&lang=js&"
export * from "./FilterBuildingType.vue?vue&type=script&lang=js&"
import style0 from "./FilterBuildingType.vue?vue&type=style&index=0&id=397d5223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d5223",
  null
  
)

export default component.exports